<svg class="close" width="18" height="18" viewBox="0 0 3 3" on:click>
  <path fill="none" stroke="currentColor" stroke-width="0.2" d="M0 0L3 3M3 0L0 3" />
</svg>

<style>
  .close {
    position: absolute;
    top: 15px;
    right: 15px;
    border: none;
    background: none;
    cursor: pointer;
    opacity: 0.4;
  }
</style>
